// Polyfills for Node.js modules in the browser
import { Buffer } from 'buffer';

// Make Buffer globally available
window.Buffer = Buffer;
globalThis.Buffer = Buffer;